import React from 'react';
// import { useTranslation } from "react-i18next";
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
// import "./index.scss";

import ContentBox from "../../../../../../ui/ContentBox";
import SkeletonLoader from "../../../../../../ui/SkeletonLoader";

const IPInformation = ({selectedIpDetails, isLoading}) => {
    return (
        <>            
            {/* <div className="hacker-score-container p-3 rounded mb-3">
                <p className="hacker-score">846<span>/900</span></p>
                <p className="hacker-text">Latest Hacker Score</p>
            </div> */}
            <div className="ip-info-container">
                {
                    isLoading ?
                    <SkeletonLoader type={"line"} count={5} currentPage={"ipaddress"} />
                    :
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4 }}
                    >
                        <Row>
                            <Col lg={6} className="mb-3">
                                <ContentBox label={"IP Address"} value={selectedIpDetails?.ip_address}/>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <ContentBox label={"Continent"} value={selectedIpDetails?.continent}/>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <ContentBox label={"Country"} value={selectedIpDetails?.country}/>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <ContentBox label={"Region"} value={selectedIpDetails?.region}/>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <ContentBox label={"City"} value={selectedIpDetails?.city}/>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <ContentBox label={"Latitude"} value={selectedIpDetails?.latitude}/>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <ContentBox label={"Longitude"} value={selectedIpDetails?.longitude}/>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <ContentBox label={"Hosting"} value={selectedIpDetails?.hosting_provider}/>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <ContentBox label={"Organization"} value={selectedIpDetails?.organization}/>
                            </Col>
                            <Col lg={6} className="mb-3">
                                <ContentBox label={"AS Details"} value={selectedIpDetails?.as_number}/>
                            </Col>
                            <Col lg={12} className="mb-3">
                                <div className="content-box-container p-3 rounded">
                                    <h4 className="label mb-3">Blacklisted AT</h4>
                                    {
                                        selectedIpDetails?.blacklisted?.blacklisted_at.length > 0 &&
                                        selectedIpDetails?.blacklisted?.blacklisted_at.map((data, index)=>{
                                            return (
                                                <span className="blacklisted-at-tags" key={index}>{data}</span>  
                                            )
                                        })                                    
                                    }
                                        
                                </div>
                            </Col>
                        </Row>
                    </motion.div>
                }                
            </div>
        </>
    )
}

export default IPInformation;